export default __webpack_public_path__ + "static/mark-bd2b08c0ec51ac465d509b36660bd2d5.png";